import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_WORLD_FIRST_TRACKER_DATA,
  SHOW_WORLD_FIRST_TRACKER_SPINNER,
  FORCE_WORLD_FIRST_REFRESH
} from '../actions/worldFirstTrackerActions';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

const DEFAULT_STATE = {
  isLoading: false,
  forceRefresh: false
};

export default function worldFirstTrackerReducer(
  state: Partial<any> = DEFAULT_STATE,
  action: TAction<any>
): Partial<any> {
  switch (action.type) {
    case SET_WORLD_FIRST_TRACKER_DATA: {
      return {
        ...state,
        ...action.payload,
        isLoading: false
      };
    }
    case SHOW_WORLD_FIRST_TRACKER_SPINNER: {
      return {
        ...state,
        isLoading: action.payload,
        forceRefresh: false
      };
    }
    case FORCE_WORLD_FIRST_REFRESH: {
      return {
        ...state,
        forceRefresh: true
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return DEFAULT_STATE;
    }
    default: {
      return state;
    }
  }
}
